import { Link } from "@/i18n/routing";
import { NewsletterSubscribe, SocialLinks } from "@repo/components";
import { getStrapiMedia } from "@repo/lib/utils";
import Image from "next/image";
const Footer = async ({
  footer
}) => {
  const footerLogo = footer?.FooterLogo;
  const footerMenu = footer?.FooterMenu;
  const footerSocialLinks = footer?.SocialLinks;
  return <footer className="bg-footer-bg border-t-footer-top border-t p-6 md:py-12" data-sentry-component="Footer" data-sentry-source-file="Footer.jsx">
      <div className="mx-auto text-sm md:max-w-screen-xl">
        <div className="border-b-footer-bottom flex flex-col justify-between gap-6 border-b py-6 md:pb-14 md:pt-0 lg:flex-row">
          {/* Footer Logo and newsletter */}
          <div className="border-b-footer-bottom flex flex-col justify-between gap-6 border-b pb-6 md:gap-10 md:border-b-0 md:pb-0">
            <div className="mx-auto max-w-[180px] md:mx-0 md:max-w-[200px]">
              {footerLogo?.image?.url && <Link title={footerLogo.image.alternativeText} href="/">
                  <Image src={getStrapiMedia(footerLogo.image.url)} alt={footerLogo.image.alternativeText} width={footerLogo.image.width} height={footerLogo.image.height} className="h-auto max-w-full" />
                </Link>}
            </div>
            <div className="hidden md:block">
              <NewsletterSubscribe placeholder={footer?.newsletterPlaceholder} data-sentry-element="NewsletterSubscribe" data-sentry-source-file="Footer.jsx" />
            </div>
          </div>
          {/* Footer Menu */}
          <div className="flex flex-wrap gap-8 pb-4 md:flex-nowrap md:justify-between md:gap-10 md:pb-0 lg:justify-end">
            {footerMenu?.map(item => <div key={item.id} className="min-w-[150px] max-w-[200px] grow md:min-w-[90px] md:max-w-[160px]">
                <span className="font-heading text-footer-text block py-1 text-base font-medium">
                  {item.heading}
                </span>
                <ul className="text-footer-link">
                  {item?.FooterLinks?.map(link => <li key={link.id}>
                      <Link href={link.url} className="inline-block py-1 transition-colors duration-200 hover:underline md:py-1.5">
                        {link.text}
                      </Link>
                    </li>)}
                </ul>
              </div>)}
          </div>
        </div>
        {/* Copyright and Social Links */}
        <div className="flex flex-col gap-4 pt-6 md:flex md:flex-row md:items-center">
          <div className="block md:hidden">
            <NewsletterSubscribe placeholder={footer?.newsletterPlaceholder} data-sentry-element="NewsletterSubscribe" data-sentry-source-file="Footer.jsx" />
          </div>
          <div className="flex justify-center md:mb-0">
            <SocialLinks socialLinks={footerSocialLinks} data-sentry-element="SocialLinks" data-sentry-source-file="Footer.jsx" />
          </div>
          <div className="order-last md:order-none md:mb-0 md:ms-auto md:justify-end">
            {footer?.copyright && <p className="pt-2 text-center text-[#B8B8B8] md:text-left">
                {footer?.copyright}
              </p>}
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;